import { Box, LoadingOverlay, Title } from '@mantine/core'
import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { extractErrorMessage } from '@/api/helpers/extractErrorMessage'
import { useCreateWorkspace } from '@/queries/workspaceQueries'
import { showToast } from '@/theme/notifications'
import { AuthLayout } from '../layout/AuthLayout/AuthLayout'
import { InviteMembersHandler } from './InviteMembers/InviteMembersHandler'
import {
  SubmitValues,
  WorkspaceSettingsForm
} from './WorkspaceSettings/WorkspaceSettingsForm'

type CreateWorkspaceHandlerProps = {
  onWorkspaceCreated: () => void
}

export const CreateWorkspaceHandler = ({
  onWorkspaceCreated
}: CreateWorkspaceHandlerProps) => {
  const intl = useIntl()
  const [workspaceId, setWorkspaceId] = useState('')

  const { mutateAsync: createWorkspace, isPending } = useCreateWorkspace()

  const handleSubmit = async (formValues: SubmitValues) => {
    try {
      const workspace = await createWorkspace({
        ...formValues,
        require_mfa: true // Enable MFA by default for new workspaces
      })

      showToast(
        intl.formatMessage({ id: 'workspace.create.success' }),
        'success'
      )

      setWorkspaceId(workspace.id)
    } catch (err) {
      showToast(
        extractErrorMessage(
          err,
          intl.formatMessage({ id: 'workspace.create.error' })
        ),
        'error'
      )
    }
  }

  return workspaceId === '' ? (
    <AuthLayout>
      <Box pos="relative">
        <LoadingOverlay visible={isPending} />

        <Title order={2} mb="xl">
          <FormattedMessage id="workspace.create" />
        </Title>

        <WorkspaceSettingsForm
          mode="create"
          buttonAlign="center"
          onSubmit={(formValues) => void handleSubmit(formValues)}
        />
      </Box>
    </AuthLayout>
  ) : (
    <InviteMembersHandler
      workspaceId={workspaceId}
      onCompleted={onWorkspaceCreated}
    />
  )
}
